import { useSelector } from 'react-redux';
import { getCustomer } from '@app/redux/customer/selectors';
import type { Customer } from '@app/types';
import { isEmpty } from 'lodash';

/**
 *
 */

const useCustomer = (): Nullable<Customer> => {
  const customer = useSelector(getCustomer) as Customer;

  if (isEmpty(customer)) {
    return null;
  }

  return customer;
};

export default useCustomer;
